var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIdea = function SvgIdea(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M11.58 13.397a.83.83 0 0 1-.787.866H9.208a.83.83 0 0 1-.786-.866v-1.681a4.697 4.697 0 1 1 6.315-4.42 4.69 4.69 0 0 1-3.158 4.42z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M11.58 12.216a.5.5 0 0 0 0-1zm-3.16-1a.5.5 0 1 0 0 1zM19 7.796a.5.5 0 0 0 0-1zm-1.895-1a.5.5 0 1 0 0 1zm-14.21 1a.5.5 0 0 0 0-1zM1 6.796a.5.5 0 0 0 0 1zm15.716-5.44a.5.5 0 0 0-.703-.712zm-2.046.615a.5.5 0 0 0 .702.711zM5.33 12.622a.5.5 0 0 0-.703-.71zm-2.042.616a.5.5 0 1 0 .703.71zm12.728.71a.5.5 0 0 0 .703-.71zm-.636-2.036a.5.5 0 0 0-.704.71zM4.627 2.682a.5.5 0 1 0 .702-.711zM3.987.644a.5.5 0 0 0-.703.712zm7.592 10.572H8.421v1h3.158zM19 6.796h-1.895v1H19zm-16.105 0H1v1h1.895zM16.013.644 14.67 1.971l.702.711 1.344-1.326zM4.627 11.912l-1.34 1.326.704.71 1.34-1.326zm12.092 1.326-1.34-1.326-.703.71 1.34 1.327zM5.33 1.971 3.987.644l-.703.712 1.344 1.326z"
  })));
};
export { SvgIdea as ReactComponent };
export default __webpack_public_path__ + "fe79cec999b33c14a5036c739aafdfc2.svg";